<form #wopiForm name="office_form" target="office_frame" method="post">
    <input name="access_token" [value]="accessToken" type="hidden" />
    <input name="access_token_ttl" [value]="accessTokenTtl" type="hidden" />
</form>

<span id="frameholder"></span>
